
import { WorldCity } from '../types';

// Expansión de ciudades del sur de China (100 ciudades adicionales)
export const chinaSouthernCities: WorldCity[] = [
  { name: 'Shantou', slug: 'shantou', population: 5502031 },
  { name: 'Zhanjiang', slug: 'zhanjiang', population: 6981236 },
  { name: 'Shaoguan', slug: 'shaoguan', population: 2855131 },
  { name: 'Zhuhai', slug: 'zhuhai', population: 2402174 },
  { name: 'Jiangmen', slug: 'jiangmen', population: 4798090 },
  { name: 'Zhaoqing', slug: 'zhaoqing', population: 4113594 },
  { name: 'Huizhou', slug: 'huizhou', population: 6042852 },
  { name: 'Meizhou', slug: 'meizhou', population: 3873239 },
  { name: 'Shanwei', slug: 'shanwei', population: 2390097 },
  { name: 'Heyuan', slug: 'heyuan', population: 2837686 },
  { name: 'Yangjiang', slug: 'yangjiang', population: 2602959 },
  { name: 'Qingyuan', slug: 'qingyuan', population: 3969473 },
  { name: 'Dongguan', slug: 'dongguan', population: 10466625 },
  { name: 'Zhongshan', slug: 'zhongshan', population: 4418060 },
  { name: 'Chaozhou', slug: 'chaozhou', population: 2568387 },
  { name: 'Jieyang', slug: 'jieyang', population: 5577814 },
  { name: 'Yunfu', slug: 'yunfu', population: 2367662 },
  { name: 'Nanning', slug: 'nanning', population: 8741584 },
  { name: 'Liuzhou', slug: 'liuzhou', population: 4157934 },
  { name: 'Guilin', slug: 'guilin', population: 4931137 },
  { name: 'Wuzhou', slug: 'wuzhou', population: 2843587 },
  { name: 'Beihai', slug: 'beihai', population: 1890065 },
  { name: 'Fangchenggang', slug: 'fangchenggang', population: 1014712 },
  { name: 'Qinzhou', slug: 'qinzhou', population: 3302238 },
  { name: 'Guigang', slug: 'guigang', population: 4118800 },
  { name: 'Yulin', slug: 'yulin-guangxi', population: 5487983 },
  { name: 'Baise', slug: 'baise', population: 3466451 },
  { name: 'Hezhou', slug: 'hezhou', population: 1954092 },
  { name: 'Hechi', slug: 'hechi', population: 3369598 },
  { name: 'Laibin', slug: 'laibin', population: 2102178 },
  { name: 'Chongzuo', slug: 'chongzuo', population: 2003330 },
  { name: 'Haikou', slug: 'haikou', population: 2873358 },
  { name: 'Sanya', slug: 'sanya', population: 1031396 },
  { name: 'Sansha', slug: 'sansha', population: 2333 },
  { name: 'Danzhou', slug: 'danzhou', population: 931218 },
  { name: 'Wuzhishan', slug: 'wuzhishan', population: 115392 },
  { name: 'Qionghai', slug: 'qionghai', population: 523851 },
  { name: 'Wanning', slug: 'wanning', population: 590771 },
  { name: 'Wenchang', slug: 'wenchang', population: 629532 },
  { name: 'Chengmai', slug: 'chengmai', population: 590503 },
  { name: 'Lingao', slug: 'lingao', population: 532988 },
  { name: 'Dingan', slug: 'dingan', population: 372915 },
  { name: 'Tunchang', slug: 'tunchang', population: 271802 },
  { name: 'Chengdu', slug: 'chengdu', population: 21192000 },
  { name: 'Zigong', slug: 'zigong', population: 2489256 },
  { name: 'Panzhihua', slug: 'panzhihua', population: 1212203 },
  { name: 'Luzhou', slug: 'luzhou', population: 4254149 },
  { name: 'Deyang', slug: 'deyang', population: 3456161 },
  { name: 'Mianyang', slug: 'mianyang', population: 4868243 },
  { name: 'Guangyuan', slug: 'guangyuan', population: 2484123 },
  { name: 'Suining', slug: 'suining', population: 3252551 },
  { name: 'Neijiang', slug: 'neijiang', population: 3702847 },
  { name: 'Leshan', slug: 'leshan', population: 3160168 },
  { name: 'Nanchong', slug: 'nanchong', population: 5607565 },
  { name: 'Meishan', slug: 'meishan', population: 2955219 },
  { name: 'Yibin', slug: 'yibin', population: 4588804 },
  { name: 'Guangan', slug: 'guangan', population: 3254643 },
  { name: 'Dazhou', slug: 'dazhou', population: 5385422 },
  { name: 'Yaan', slug: 'yaan', population: 1434603 },
  { name: 'Bazhong', slug: 'bazhong', population: 2712894 },
  { name: 'Ziyang', slug: 'ziyang', population: 2308631 },
  { name: 'Aba', slug: 'aba', population: 897239 },
  { name: 'Ganzi', slug: 'ganzi', population: 1091872 },
  { name: 'Liangshan', slug: 'liangshan', population: 5194882 },
  { name: 'Guiyang', slug: 'guiyang', population: 5987018 },
  { name: 'Liupanshui', slug: 'liupanshui', population: 3031602 },
  { name: 'Zunyi', slug: 'zunyi', population: 6606675 },
  { name: 'Anshun', slug: 'anshun', population: 2297339 },
  { name: 'Bijie', slug: 'bijie', population: 6899636 },
  { name: 'Tongren', slug: 'tongren', population: 3156665 },
  { name: 'Qianxinan', slug: 'qianxinan', population: 3648430 },
  { name: 'Qiandongnan', slug: 'qiandongnan', population: 4468671 },
  { name: 'Qiannan', slug: 'qiannan', population: 4067833 },
  { name: 'Kunming', slug: 'kunming', population: 8460088 },
  { name: 'Qujing', slug: 'qujing', population: 5765775 },
  { name: 'Yuxi', slug: 'yuxi', population: 2367886 },
  { name: 'Baoshan', slug: 'baoshan', population: 2506615 },
  { name: 'Zhaotong', slug: 'zhaotong', population: 5092611 },
  { name: 'Lijiang', slug: 'lijiang', population: 1253878 },
  { name: 'Puer', slug: 'puer', population: 2196712 },
  { name: 'Lincang', slug: 'lincang', population: 2248502 },
  { name: 'Chuxiong', slug: 'chuxiong', population: 2684169 },
  { name: 'Honghe', slug: 'honghe', population: 4478422 },
  { name: 'Wenshan', slug: 'wenshan', population: 3670876 },
  { name: 'Xishuangbanna', slug: 'xishuangbanna', population: 1301407 },
  { name: 'Dali', slug: 'dali', population: 3337585 },
  { name: 'Dehong', slug: 'dehong', population: 1315709 },
  { name: 'Nujiang', slug: 'nujiang', population: 534337 },
  { name: 'Diqing', slug: 'diqing', population: 387511 },
  { name: 'Lhasa', slug: 'lhasa', population: 951800 },
  { name: 'Shigatse', slug: 'shigatse', population: 798153 },
  { name: 'Chamdo', slug: 'chamdo', population: 760966 },
  { name: 'Nyingchi', slug: 'nyingchi', population: 238131 },
  { name: 'Shannan', slug: 'shannan', population: 372793 },
  { name: 'Naqu', slug: 'naqu', population: 514715 },
  { name: 'Ali', slug: 'ali', population: 123281 },
  { name: 'Xian', slug: 'xian', population: 12952907 },
  { name: 'Tongchuan', slug: 'tongchuan', population: 702344 },
  { name: 'Baoji', slug: 'baoji', population: 3321853 },
  { name: 'Xianyang', slug: 'xianyang', population: 4837620 },
  { name: 'Weinan', slug: 'weinan', population: 4688744 },
  { name: 'Yanan', slug: 'yanan', population: 2187009 },
  { name: 'Hanzhong', slug: 'hanzhong', population: 3211462 },
  { name: 'Yulin', slug: 'yulin-shaanxi', population: 3380138 },
  { name: 'Ankang', slug: 'ankang', population: 2645000 },
  { name: 'Shangluo', slug: 'shangluo', population: 2341742 }
];
